<template>
  <div class="page">
    <!-- 页头 -->
    <home-header :currentMenuId="6"></home-header>

    <!-- 内容 -->
    <div class="content-box">
      <!-- 第一模块 -->
      <div class="f-module">
        <div class="left-box">
          <h2 class="title">一站式数据分析服务平台</h2>
          <span class="text">让数据成为企业核心资产，助力企业实现数字化决策</span>
          <a :href="Confluence_join" target="_blank" class="butn">立即接入</a>
        </div>
        <div class="right-box">
          <img src="../img/home/home-1.png" />
        </div>
      </div>

      <!-- 第二模块 -->
      <div class="module s-module">
        <h2 class="title">产品优势</h2>
        <div class="text">英雄大数据中心为每一个接入游戏提供采集、存储、建模到分析的全流程服务，提升数据价值</div>
        <div class="box">
          <div class="item-box" v-for="(item,index) in dataList" :key="index">
            <img class="icon" :src="item.icon" />
            <div class="text-box">
              <div class="name">{{item.title}}</div>
              <div class="desc">{{item.desc}}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三模块 -->
      <div class="module t-module pc-module">
        <h2 class="title">产品介绍</h2>
        <div class="box">
          <div class="left-box">
            <div class="t-item" v-for="(item,index) in productList" :key="index">
              <div class="t-item-title" v-if="currentProduct.title !== item.title" @mouseenter="mouseEnter(item,index)">
                <i class="circle"></i>
                <div class="name">{{item.title}}</div>
              </div>
              <div class="desc-box" v-else>
                <div class="desc-title">
                  <i class="circle"></i>
                  <div class="name">{{item.title}}</div>
                </div>
                <div class="desc">{{item.desc}}</div>
                <a :href="item.link" target="_blank" class="butn">开始使用</a>
              </div>
            </div>
          </div>
          <div class="right-box">
            <img class="img" :src="currentProduct.img">
          </div>
        </div>
      </div>

      <div class="module t-module mb-module">
        <h2 class="title">产品介绍</h2>

            <el-tabs :stretch="true">
                <el-tab-pane :label="item.title" v-for="(item,index) in productList" :key="index">
                    <div class="desc">{{item.desc}}</div>
                    <img class="img" :src="item.img">
                </el-tab-pane>
            </el-tabs>
      </div>
    </div>

    <!-- 浮层 -->
    <home-suspend></home-suspend>

    <!-- 页脚 -->
    <home-footer></home-footer>
  </div>
</template>

<script>
import HomeHeader from '../components/header'
import HomeFooter from '../components/footer'
import HomeSuspend from '../components/suspend'
import Link from '../components/link'
export default {
  components: { HomeHeader, HomeFooter, HomeSuspend },
  data() {
    return {
      Confluence_join: Link.Confluence_join,
      dataList: [
        {
          title: '双端采集，高效准确',
          desc: '支持客户端、服务端双端数据采集，为游戏提供全生命周期，多业务场景的数据服务，助力打造精品游戏',
          icon: require('../img/home/icon-1.png')
        },
        {
          title: '海量数据，快速响应',
          desc: '应用主流大数据技术架构，支持海量数据计算和业务分析，为项目提供稳定、可靠、性能优质的数据根基平台',
          icon: require('../img/home/icon-2.png')
        },
        {
          title: '数据中台，赋能业务',
          desc: '完善的数据中台服务，解决数据的“存”、“通”、“用”难题，连接数据孤岛，让业务数据化，让数据业务化',
          icon: require('../img/home/icon-3.png')
        },
        {
          title: '内部资产，高效管理',
          desc: '完善的资产管理平台，沉淀内部开发文档和美术资源，高效管理企业资产',
          icon: require('../img/home/icon-4.png')
        }
      ],
      productList: [
        {
          title: '运营数据平台',
          desc: '集数据接入、定制化报表和自定义分析为一体的游戏运营数据服务平台',
          img: require('../img/home/bdc.png'),
          link: Link.Bdc
        },
        {
          title: '客服查询平台',
          desc: '游戏玩家明细信息查询平台，以便于维护玩家和管控游戏热度',
          img: require('../img/home/gms.png'),
          link: Link.Gms
        },
        // {
        //   title: '广告监测平台',
        //   desc: '提供精准归因，监测推广数据，深度追踪游戏内转化事件，优化买量策略，提升ROI',
        //   img: require('../img/home/ads-track.png'),
        //   link: Link.Ad_Tracking
        // },
        // {
        //   title: '广告投放平台',
        //   desc: '集中管理广告主在主流媒体平台的推广活动，批量创建广告，统一管理预算',
        //   img: require('../img/home/ads-desk.png'),
        //   link: Link.Ad_Desk_New
        // },
        {
          title: '自助化分析平台',
          desc: '以数据模型和可视化配置为核心、以数据看板为应用的分析平台',
          img: require('../img/home/df-desk.png'),
          link: Link.Df
        },
        {
          title: '舆情分析平台',
          desc: '基于热门游戏关键词，分析视频平台UP主的热度数据',
          img: require('../img/home/nms-desk.png'),
          link: Link.Nms
        }
      ],
      currentProduct: {}
    }
  },
  created() {
    this.currentProduct = this.productList[0]
  },
  methods: {
    // 移入
    mouseEnter(item) {
      this.currentProduct = item
    }
  }
}
</script>

<style lang="scss" scoped>
.content-box {
  margin-top: 72px;
}
.pc-module {
  display: flex !important;
}
.mb-module {
  display: none !important;
}
.f-module {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .left-box {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
  }
  .title {
    margin: 0;
    font-size: 42px;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
  }
  .text {
    font-size: 20px;
    color: #666666;
    line-height: 1.2;
    margin-top: 20px;
  }

  img {
    display: block;
    width: auto;
    height: 500px;
    position: absolute;
    top: 0;
    z-index: 1;
  }
  .butn {
    margin-top: 58px;
    width: 132px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: #3a89ff;
    border-radius: 4px;
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      opacity: 0.8;
      transform: translate3d(5px, 5px, 0);
    }
  }
}
.f-module {
  height: 400px;
  overflow: hidden;
  background: linear-gradient(180deg, #f8fbff 0%, #f1f8ff 100%);
}
.f-module {
  padding-left: 9vw;
  .left-box {
    align-items: flex-start;
    margin-right: 4vw;
  }
  .right-box {
    flex-shrink: 0;
    min-width: 770px;
    width: 50vw;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
}

.module {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .title {
    margin: 0;
    font-size: 36px;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
  }
  .text {
    margin-top: 16px;
    font-size: 18px;
    color: #999999;
    line-height: 1.2;
  }
}
.s-module {
  // height: 558px;
  margin: 80px auto;
  .box {
    margin-top: 40px;
    padding: 0 4.1%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
  }
  .item-box {
    min-width: 510px;
    width: 38%;
    flex-shrink: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 20px 2.4%;
    .icon {
      flex-shrink: 0;
      width: 56px;
      height: 56px;
      margin-right: 32px;
    }
    .text-box {
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      .name {
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
      }
      .desc {
        margin-top: 12px;
        font-size: 16px;
        line-height: 1.4;
        color: #666666;
      }
    }
  }
}
.t-module {
  height: 650px;
  background: #f1f9ff;
  .box {
    margin-top: 60px;
    width: 100%;
    padding: 0 0px 0 5.6vw;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;
  }
  .left-box {
    flex-grow: 1;
    width: 30vw;
    margin: 0 4.5vw 0 3.5vw;
  }
  .right-box {
    flex-shrink: 0;
    min-width: 740px;
    width: 52vw;
    // transition: opacity 0.3s ease-in-out;
    .img {
      width: 650px;
      height: 350px;
    }
  }

  .t-item {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    .t-item-title {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      transition: height 0.3s ease-in-out;
      cursor: pointer;
      margin-bottom: 16px;
    }
    .circle {
      width: 10px;
      height: 10px;
      background: #dddddd;
      border-radius: 100%;
      margin-right: 40px;
    }
    .name {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 26px;
    }
    .desc-box {
      width: 100%;
      height: auto;
      margin-left: 50px;
      margin-bottom: 26px;
      transition: height 0.35s ease-in-out;
      .desc-title {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        margin-left: -50px;
        cursor: pointer;
      }
      .circle {
        background: #3a89ff;
      }
      .name {
        font-size: 32px;
        font-weight: 500;
        color: #333333;
        line-height: 46px;
      }

      .desc {
        //display: none;
        margin-top: 24px;
        font-size: 18px;
        font-weight: 400;
        color: #666666;
        line-height: 1.4;
      }

      .butn {
        display: block;
        margin-top: 24px;
        width: 88px;
        height: 36px;
        background: #3a89ff;
        border-radius: 4px;
        text-align: center;
        line-height: 36px;
        color: #ffffff;
        cursor: pointer;
        // transition: all 0.3s;

        &:hover {
          opacity: 0.8;
          // transform: translate3d(5px, 5px, 0);
        }
      }
    }
  }

  // .t-current-item{
  //     .t-item-title{
  //         opacity: 0;
  //     }
  //     .desc-box{
  //         height: auto;
  //         margin-bottom: 26px;
  //         opacity: 1;
  //     }
  // }
}
</style>

<style lang="scss" scoped>
/*小于等于1240px */
@media (max-width: 1240px) {
  .content-box {
    min-width: 375px;
  }
  .pc-module {
    display: none !important;
  }
  .mb-module {
    display: block !important;
  }
  .module {
    display: block;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    // align-items: center;
    width: 100%;
    text-align: center;

    .left-box {
      display: block;
      // flex-flow:;
      // justify-content: center;
    }
    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 60px;
    }
    .text {
      font-size: 13px;
      color: #666666;
      line-height: 1.4;
      margin-top: 20px;
    }
    .butn-box {
      text-align: center;
      display: block;

      .butn {
        display: inline-block;
      }
      .link_butn {
        display: none;
      }
    }
  }
  .f-module {
    display: inline-block;
    width: 100%;
    text-align: center;
    height: auto;
    padding: 30px 5% 0px 5%;

    .left-box {
      display: inline-block;
      margin-right: auto;
      .butn {
        display: none;
      }

      .title {
        margin: 0;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        line-height: 60px;
      }
      .text {
        font-size: 13px;
        color: #666666;
        line-height: 1.4;
        margin-top: 20px;
      }
    }
    .right-box {
      display: inline-block;
      min-width: auto;
      width: 100%;
      align-items: initial;

      img {
        position: relative;
        width: 100%;
        height: auto;
      }
    }
  }

  .s-module {
    height: auto;
    padding: 30px 5% 20px 5%;

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #333;
      line-height: 60px;
    }
    .text {
      font-size: 13px;
      color: #999;
      line-height: 1.4;
      margin-top: 20px;
    }

    .box {
      display: inline-block;
padding:0px 1%;
margin-top: 20px;
      .item-box {
        width: 100%;
        // display:inline-block;
        margin:20px 1%;
        min-width: auto;
        .icon{
            margin-right: 5%;
        }
        .text-box {
          text-align: left;
          .name{
              font-size: 16px;
          }
          .desc{
              font-size: 10px;
              margin-top:5px;
          }
        }
      }
    }
  }

  .t-module {
    height: auto;
    padding: 30px 0% 20px 0%;
    position: relative;
    background: linear-gradient(131deg, #ffffff 30%, #e3ecf6 140%);
    .pc_right {
      display: none;
    }
    .mb_right {
      display: inline-block;
    }

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #333;
      line-height: 60px;
    }


    ::v-deep .el-tabs__item{
        padding: 0 !important;
        font-size: 12px;
    }

    ::v-deep .el-tabs__nav-wrap::after{
        opacity: 0.3;
    }

    .desc{
        padding: 10px 5%;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
    }

    .img{
        width: 90%;   
    }
  }
}
</style>